/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, NgZone, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/providers/apiService/api.service';
import * as moment from 'moment';
import { ToastService } from 'src/app/providers/toastService/toast.service';
import { ActionSheetController, AlertController, IonAccordionGroup, LoadingController, ModalController, NavController } from '@ionic/angular';
import { Chooser } from '@awesome-cordova-plugins/chooser/ngx';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { DoctorsListComponent } from 'src/app/components/doctors-list/doctors-list.component';
import { ItemListComponent } from 'src/app/components/item-list/item-list.component';
import { IonicSelectableComponent } from 'ionic-selectable';
import { StorageService } from 'src/app/providers/storageService/storage.service';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { formatDate } from '@angular/common';
import { AccessService } from 'src/app/providers/access/access.service';
import { Capacitor } from "@capacitor/core";
@Component({
  selector: 'app-anaesthetica',
  templateUrl: './anaesthetica.page.html',
  styleUrls: ['./anaesthetica.page.scss'],
})
export class AnaestheticaPage {
  @ViewChild('serviceDateAccordion', { static: true }) serviceDateAccordion: IonAccordionGroup;
  @ViewChild('startTimeAccordion', { static: true }) startTimeAccordion: IonAccordionGroup;
  @ViewChild('endTimeAccordion', { static: true }) endTimeAccordion: IonAccordionGroup;

  anaesheticaForm: FormGroup;
  selectedArray = [];
  otherItem = [];
  customAlertOptions = {
    header: 'Select Item(s)',
  };

  toogle = [
    { id: 0, title: 'No Gap', checked: false },
    { id: 1, title: 'Known Gap', checked: false },
    { id: 2, title: 'Full Fee', checked: false },
  ];
  consultItems = ['17610', '17615', '17620', '17640', '17645', '17650', '17655', '17680', '17690'];
  itemNumber: any = ['25000', '25005', '25010', '25013', '25014', '25025', '25030', '25050'];
  initiationItems: any = ['20100', '20102', '20104', '20120', '20124', '20140', '20142', '20143', '20144', '20145', '20146', '20147', '20148',
    '20160', '20162', '20164', '20170', '20172', '20174', '20176', '20190', '20192', '20210', '20212', '20214', '20216', '20220', '20222', '20225', '20230', '20300', '20305', '20320', '20321', '20330', '20350', '20352', '20355', '20400', '20401', '20402', '20403', '20404', '20405', '20406', '20410',
    '20420', '20440', '20450', '20452', '20470', '20472', '20474', '20475', '20500', '20520', '20522', '20524', '20526', '20528', '20540', '20542', '20546',
    '20548', '20560', '20600', '20604', '20620', '20622', '20630', '20632', '20634', '20670', '20680', '20690', '20700', '20702', '20703', '20704', '20705',
    '20706', '20730', '20740', '20745', '20750', '20752', '20754', '20756', '20770', '20790', '20791', '20792', '20793', '20794', '20798', '20799',
    '20800', '20802', '20803', '20804', '20805', '20806', '20810', '20815', '20820', '20830', '20832', '20840', '20841', '20842', '20844', '20845',
    '20846', '20847', '20848', '20850', '20855', '20860', '20862', '20863', '20864', '20866', '20867', '20868', '20880', '20882', '20884', '20886', '20900',
    '20902', '20904', '20905', '20906', '20910', '20911', '20912', '20914', '20916', '20920', '20924', '20926', '20928', '20930', '20932', '20934',
    '20936', '20938', '20940', '20942', '20943', '20944', '20946', '20948', '20950', '20952', '20953', '20954', '20956', '20958', '20960', '21100',
    '21110', '21112', '21114', '21116', '21120', '21130', '21140', '21150', '21155', '21160', '21170', '21195', '21199', '21200', '21202', '21210',
    '21212', '21214', '21216', '21220', '21230', '21232', '21234', '21260', '21270', '21272', '21274', '21275', '21280', '21300', '21321', '21340', '21360',
    '21380', '21382', '21390', '21392', '21400', '21402', '21403', '21404', '21420', '21430', '21432', '21440', '21445', '21460', '21461', '21462', '21464',
    '21472', '21474', '21480', '21482', '21484', '21486', '21490', '21500', '21502', '21520', '21522', '21530', '21532', '21535', '21600', '21610',
    '21620', '21622', '21630', '21632', '21634', '21636', '21638', '21650', '21652', '21654', '21656', '21670', '21680', '21682', '21685', '21700', '21710',
    '21712', '21714', '21716', '21730', '21732', '21740', '21756', '21760', '21770', '21772', '21780', '21785', '21790', '21800', '21810', '21820', '21830',
    '21832', '21834', '21840', '21842', '21850', '21860', '21865', '21870', '21872', '21878', '21879', '21880', '21881', '21882', '21883', '21884', '21885',
    '21886', '21887', '21900', '21906', '21908', '21910', '21912', '21914', '21915', '21916', '21918', '21922', '21925', '21926', '21927', '21930', '21935', '21936',
    '21939', '21941', '21942', '21943', '21945', '21949', '21952', '21955', '21959', '21962', '21965', '21969', '21970', '21973', '21976', '21980', '21981', '21990',
    '21992', '21997'];
  hospitalId: any;
  hospitalList: any;
  user: any;
  disableButton = false;
  data: any;
  imageUrl: string;
  imagesArray: any = [];
  serviceDate: any;
  startTime: any;
  endTime: any;
  thisVersion:string;
  patientType: string;
  minDate = moment().format();
  public numberMask = createNumberMask({
    prefix: '$',
    allowDecimal: true,
    includeThousandsSeparator: false
  });
  mbsValidateitems = [];
  selectedAdditionalItem = null;
  errorMessages = {
    referringProviderF: [{ type: 'required', message: ' Enter Referring Provider First' }],
    referringProviderL: [{ type: 'required', message: ' Enter Referring Provider Last' }],
    serviceDate: [{ type: 'required', message: ' Choose Service Date' }],
    startTime: [{ type: 'required', message: ' Choose Start Time' }],
    endTime: [{ type: 'required', message: ' Choose End Time' }],
  };
  checkItemsArray: any[];
  constructor(
    public formBuilder: FormBuilder,
    public router: Router,
    private apiService: ApiService,
    public route: ActivatedRoute,
    public toastService: ToastService,
    public navCtrl: NavController,
    private chooser: Chooser,
    public actionSheetController: ActionSheetController,
    public modalController: ModalController,
    private storageService: StorageService,
    private ngZone: NgZone,
    public alertController: AlertController,
    private appVersion: AppVersion, 
    private loadingController: LoadingController,
    public accessService: AccessService,
  ) {

    
  this.appVersion.getVersionNumber().then((res)=>{
    this.thisVersion = res;
  });

    this.anaesheticaForm = this.formBuilder.group({
      editing: [''],
      User: this.user,
      referringProviderF: ['', Validators.required],
      referringProviderL: ['', Validators.required],
      referringProvider: [''],
      serviceDate: [moment().format(), Validators.required],
      startTime: [moment().format(), Validators.required],
      endTime: [moment().format(), Validators.required],
      consultItem: [[]],
      initiationItem: [[]],
      itemListAdditional: [[]],
      itemList: [[]],
      gap: [false],
      knownGap: [false],
      fullFee: [false],
      billType: ['anaesthetics'],
      comments: [''],
      amountType: [''],
      amount: [''],
      submission_id: [''],
      hospital: [''],
      ionicSelect: [[]], 
      version: this.thisVersion,
      platform: Capacitor.getPlatform(),
    });
    this.serviceDate = moment().format();
    this.startTime = moment().format();
    this.endTime = moment().format();
    this.editdata();
    this.getHospitalList();
  }

  ngOnInit() {
    this.anaesheticaForm.controls.gap.setValue(true);
    this.serviceDate = moment().format();
    this.startTime = moment().format();
    this.endTime = moment().format();
    this.anaesheticaForm.controls.serviceDate.setValue(this.serviceDate);
    this.anaesheticaForm.controls.startTime.setValue(this.startTime);
    this.anaesheticaForm.controls.endTime.setValue(this.endTime);
    this.storageService.get('state').then((data) => {
      //console.log('state data', data);
      this.patientType = data;
    });
  }
  ionViewDidEnter() {
    this.accessService.resetLogoutTimer();
  }
  editdata() {
    if (this.router.getCurrentNavigation().extras.state) {
      this.data = this.router.getCurrentNavigation().extras.state;
      this.anaesheticaForm.controls.editing.setValue(this.data.id);
      this.anaesheticaForm.controls.submission_id.setValue(this.data.Data.id);
      var refF = this.data.Data.referring_provider.split(" ")[0];
      this.anaesheticaForm.controls.referringProviderF.setValue(refF);
      this.anaesheticaForm.controls.referringProviderL.setValue(this.data.Data.referring_provider.replace(refF + " ",""));
      this.anaesheticaForm.controls.hospital.setValue(this.data.Data.hospital);
      this.anaesheticaForm.controls.serviceDate.setValue(this.data.Data.service_date);
      if (this.data.Data.service_date)
      {
        this.serviceDate = this.data.Data.service_date;
      }
      this.anaesheticaForm.controls.startTime.setValue(this.data.Data.start_time);
      if (this.data.Data.start_time)
      {
        this.startTime = this.data.Data.start_time;
      }
      this.anaesheticaForm.controls.endTime.setValue(this.data.Data.end_time);
      if (this.data.Data.end_time)
      {
        this.endTime = this.data.Data.end_time;
      }
      this.anaesheticaForm.controls.consultItem.setValue(this.data.Data.consult_item);
      this.anaesheticaForm.controls.initiationItem.setValue(this.data.Data.initiation_item);
      this.anaesheticaForm.controls.comments.setValue(this.data.Data.comments);
      this.anaesheticaForm.controls.amountType.setValue(this.data.Data.amount_type);
      // this.amount =this.data.gap_amount;
    };
  }

  toogleChange(args: string) {
    switch (args) {
      case 'gap':
        this.anaesheticaForm.controls.knownGap.setValue(false);
        this.anaesheticaForm.controls.fullFee.setValue(false);
        break;
      case 'knownGap':
        this.anaesheticaForm.controls.gap.setValue(false);
        this.anaesheticaForm.controls.fullFee.setValue(false);
        break;
      case 'fullFee':
        this.anaesheticaForm.controls.gap.setValue(false);
        this.anaesheticaForm.controls.knownGap.setValue(false);
        break;
      default:
        this.anaesheticaForm.controls.gap.setValue(false);
        this.anaesheticaForm.controls.knownGap.setValue(false);
        this.anaesheticaForm.controls.fullFee.setValue(false);
    }
  }

  selectSize(itemNumber: any, isChecked: any) {
    if (isChecked.detail.checked) {
      this.selectedArray.push(itemNumber);
    } else {
      const index = this.selectedArray.indexOf(itemNumber);
      this.selectedArray.splice(index, 1);
    }
    this.anaesheticaForm.controls.itemList.setValue(this.selectedArray);
  }


  async submit() {
    if (this.anaesheticaForm.valid) {
      this.anaesheticaForm.controls.referringProvider.setValue(
        this.anaesheticaForm.controls.referringProviderF.value + " " + this.anaesheticaForm.controls.referringProviderL.value
      );

      const alert = await this.alertController.create({
        cssClass: 'success_alert', 
        header: 'Please Confirm',
        mode:'ios',
        animated: true,
        message: ('Are you sure you want to submit billing for '+ this.data.Data.patient_first_name + ' ' + this.data.Data.patient_last_name)+' <br><br>Please be patient once you submit your billing.  During submission, your billing request information is collected before producing a reference number.  Please wait until you receive confirmation of a successful submission.',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'red',
            handler: (blah) => {
            }
          }, {
            text: 'Submit',
            cssClass: 'buttonUpdate',
            handler: () => {
              this.submitBilling();
            }
          } 
      
      ] });
      await alert.present();
    } else {
      // eslint-disable-next-line guard-for-in
      for (const property in this.anaesheticaForm.value) {
        this.anaesheticaForm.controls[property].markAsTouched();
      }
      this.anaesheticaForm.markAsTouched();
    }
  }
  submitBilling() {
      const additionalArr = [];
      if (this.anaesheticaForm.value.ionicSelect.length) {
        for (let i = 0; i < this.anaesheticaForm.value.ionicSelect.length; i++) {
          //console.log(this.anaesheticaForm.value.ionicSelect[i]);
          additionalArr.push(this.anaesheticaForm.value.ionicSelect[i]);
        }
        this.anaesheticaForm.controls.itemListAdditional.setValue(additionalArr);
      }
      let thisServiceDate = new Date(this.anaesheticaForm.controls.serviceDate.value);
      let thisStartTime = new Date(this.anaesheticaForm.controls.startTime.value);
      let thisEndTime = new Date(this.anaesheticaForm.controls.endTime.value);
      
      this.anaesheticaForm.controls.serviceDate.setValue(
        formatDate(thisServiceDate, 'yyyy-MM-dd', 'en-AU')
      );
      //console.log(this.anaesheticaForm.controls.startTime.value);
      //console.log(new Date(this.anaesheticaForm.controls.startTime.value).format('HH:mm'));
      this.anaesheticaForm.controls.startTime.setValue(
        formatDate(thisStartTime, 'HH:mm', 'en-AU')
      );

      this.anaesheticaForm.controls.endTime.setValue(
        formatDate(thisEndTime, 'HH:mm', 'en-AU')
      );
      // hh:mm:ss
      delete this.anaesheticaForm.value.ionicSelect;
      this.disableButton = true;
      this.anaesheticaForm.controls.version.setValue(this.thisVersion);
      let loading = null;
        this.loadingController.create({
          message: 'Please wait while we submit your billing.  Once successfully submitted, you will receive a submission and billing reference number.',
          spinner: "circles"
          // You can customize options here
        }).then((loadingInstance) => {
          loading = loadingInstance;
          loading.present();
        });
      this.apiService.post('data/another-billing', this.anaesheticaForm.value).subscribe(
        (res) => {
          if (res.error === false) {
            //this.toastService.presentToast( 'success', 'Submitted Successfully' );
            // this.navCtrl.navigateRoot('/home');
            this.storageService.remove('state');
            let ref = 'Submission ID: ' + this.anaesheticaForm.value['submission_id'];
            if (res.data.ref)
            {
              ref = 'Submission ID: ' + this.anaesheticaForm.value['submission_id'] + '<br>Billing Ref: ' + res.data.ref;
            }
            loading.dismiss();
            this.presentSuccessfulSubmissionAlert('You have successfully submitted billing to Medbill. You will receive a confirmation email shortly.<br><br>' + ref);
             
              if (this.patientType == 'patient') {
                this.router.navigateByUrl('/submission'); 

              } else {
                this.router.navigateByUrl('/ward-round'); 
                /*this.toastService.presentToast( 'success', 'Submitted Successfully' );
                this.storageService.remove('state');
                this.navCtrl.pop().then(() => {
                  this.navCtrl.pop();
                });*/
              }
          }
          else
          {
            loading.dismiss();
            this.presentFailedSubmissionAlert('There was a problem with your submission:<br><br>'+res.error.message);
            this.router.navigateByUrl('/home');
          }
        },
        (err) => { 
          loading.dismiss();
          this.presentFailedSubmissionAlert('There was a problem with your submission.');
          this.router.navigateByUrl('/home');
        }
      );
  }

  async presentSuccessfulSubmissionAlert(alertmsg) {
    const alert = await this.alertController.create({
      cssClass: 'success_alert', 
      header: 'Submission Successful',
      message: alertmsg,
      buttons: ['OK'],
    });
    await alert.present();
  }

  async presentFailedSubmissionAlert(alertmsg) {
    const alert = await this.alertController.create({
      cssClass: 'fail_alert', 
      header: 'Submission Failed',
      message: alertmsg,
      buttons: ['OK'],
    });
    await alert.present();
  }

  getHospitalList() {
    this.apiService.post('hospital-list', {}).subscribe(
      (res) => {
        if (res.error === false) {
          this.hospitalList = res.data.hospitals;
          this.anaesheticaForm.controls.hospital.setValue(this.data.Data.hospital);
        }
      },
      (err) => { }
    );
  }

  presentModal() {
    this.modalController.create({
      component: DoctorsListComponent,
      // cssClass: 'billing-modal',
      showBackdrop: true,
      backdropDismiss: true
    }).then(res => {
      res.present();
      res.onDidDismiss().then((doctor: any) => {
        if (doctor && doctor.data) {
          this.anaesheticaForm.controls.referringProvider.setValue(doctor.data);
        }
      });
    });
  }

  getItems(args) {
    if (args && args.text) {
      const payload = {
        search: args.text,
      };
      this.apiService.post('data/check-item-exist', payload).subscribe(
        (res) => {
          if (res.error === false) {
            this.mbsValidateitems = res.data;
          }
        },
        (err) => {
        }
      );
    }
  }

  portChange(args) {
    if (args.value) {
      const additionalItem = args.value.map(e => Number(e.ItemNum));
      this.anaesheticaForm.controls.itemListAdditional.setValue(additionalItem);
    }
  }

  openItemModal() {
    this.modalController.create({
      component: ItemListComponent,
      showBackdrop: true,
      backdropDismiss: true,
      componentProps: {
        selectedVal: this.anaesheticaForm.value.ionicSelect,
      },
    }).then(res => {
      res.present();
      res.onDidDismiss().then((items: any) => {
        if (items && items.data) {
          this.ngZone.run(() => {
            const arr = [];
            for (let i = 0; i < items.data.length; i++) {
              arr.push(items.data[i]);
            }
            this.anaesheticaForm.controls.ionicSelect.setValue(arr);
          });
        }
      });
    });
  }

  updateServiceDate($event) {
    this.serviceDate = $event.detail.value;
    this.serviceDateAccordion.value = undefined;
  }
  updateStartTime($event) {
    this.startTime = $event.detail.value;
    this.startTimeAccordion.value = undefined;
  }
  updateEndTime($event) {
    this.endTime = $event.detail.value;
    this.endTimeAccordion.value = undefined;
  }
  clearDoctor() {
    this.anaesheticaForm.controls.referringProvider.setValue("");
  }
}
